import { memo } from 'react';
import { Box, Flex, Skeleton } from '@chakra-ui/react';

import { PLAN_KPI_SELECTED_BG, PLAN_TABLE_METRIC_COLUMN_MIN_WIDTH } from '../planPageRevampUi';

interface Properties {
  rowCount?: number;
  columnCount?: number;
}

const skeletonProperties = {
  startColor: 'gray.100',
  endColor: 'gray.200',
  borderRadius: '4px',
} as const;

const PlanDataTableBodySkeleton = ({ rowCount = 8, columnCount = 6 }: Properties) => (
  <Box w='100%' minH='200px'>
    <Flex
      position='sticky'
      top={0}
      zIndex={2}
      bg={PLAN_KPI_SELECTED_BG}
      borderBottom='1px solid'
      borderColor='gray.200'
    >
      <Box
        flexShrink={0}
        minW={PLAN_TABLE_METRIC_COLUMN_MIN_WIDTH}
        w={PLAN_TABLE_METRIC_COLUMN_MIN_WIDTH}
        py={3}
        px={3}
        borderRight='1px solid'
        borderColor='gray.200'
      >
        <Skeleton height='12px' width='72px' {...skeletonProperties} />
      </Box>
      {Array.from({ length: columnCount }, (_, index) => (
        <Box
          key={index}
          flex='1'
          minW='122px'
          py={3}
          px={5}
          borderRight='1px solid'
          borderColor='gray.200'
        >
          <Flex justifyContent='flex-end'>
            <Skeleton height='12px' width='64px' {...skeletonProperties} />
          </Flex>
        </Box>
      ))}
    </Flex>

    {Array.from({ length: rowCount }, (_, rowIndex) => (
      <Flex key={rowIndex} borderBottom='1px solid' borderColor='gray.100'>
        <Box
          flexShrink={0}
          minW={PLAN_TABLE_METRIC_COLUMN_MIN_WIDTH}
          w={PLAN_TABLE_METRIC_COLUMN_MIN_WIDTH}
          py={3}
          px={3}
          bg={PLAN_KPI_SELECTED_BG}
          borderRight='1px solid'
          borderColor='gray.200'
        >
          <Skeleton height='12px' width='120px' {...skeletonProperties} />
        </Box>
        {Array.from({ length: columnCount }, (__, columnIndex) => (
          <Box
            key={columnIndex}
            flex='1'
            minW='122px'
            py={3}
            px={5}
            borderRight='1px solid'
            borderColor='gray.100'
          >
            <Flex justifyContent='flex-end'>
              <Skeleton height='12px' width='80px' {...skeletonProperties} />
            </Flex>
          </Box>
        ))}
      </Flex>
    ))}
  </Box>
);

export default memo(PlanDataTableBodySkeleton);
